const PARTNER_PAYOUT_ACCRUAL = 'PARTNER_PAYOUT_ACCRUAL';

const currencys = {
  'RUB': 'rubles',
  'EUR': 'euro',
};

const types = {
  'PURCHASE': 'positive',
  'TRANSFER': 'positive',
  'PAYOUT': 'value-negative-sign',
  'PURCHASE_BILL': 'positive',
  'REFUND': 'value-negative-sign',
  'SERVICE_DEBIT_MERCHANT': 'positive',
};

const iconStyle = {
  'TRANSFER': 'transfer',
  'PAYOUT': 'withdrawal',
  'PURCHASE': 'transfer',
  'SERVICE_DEBIT_MERCHANT': 'transfer',
  'CASUAL': 'bill',
  'SUBSCRIPTION': 'bill',
  'TARIFF': 'bill',
  'PURCHASE_BILL': 'transfer',
  'REFUND': 'refund',
  'CONFIRM_CARD': 'transfer',
  'REFUND_DEBIT': 'transfer',
  [PARTNER_PAYOUT_ACCRUAL]: 'partner',
  'TICKET': 'bill ticket',
  'TIPS': 'bill tips',
};

export const getCurrencyClass = {
  methods: {
    getCurrencyClass(value) {
      return currencys[value];
    },
  },
};

export const getTypeClass = {
  methods: {
    getTypeClass(value) {
      return types[value];
    },
  },
};

const BILL_TYPES = [
  'CASUAL',
  'SUBSCRIPTION',
  'TARIFF',
  'TICKET',
  'TIPS',
];

export const transactionTypeIs = {
  methods: {
    // eslint-disable-next-line complexity
    transactionTypeIs(transaction, type) {
      const [t, status] = [transaction.type, transaction.status];

      switch (type) {
        case 'orders': // зелёненькие
          return t === 'PURCHASE' || (t === 'PURCHASE_BILL' && status !== 'CREATED' && status !== 'DECLINE') || t === 'CONFIRM_CARD' || t === 'REFUND_DEBIT' || t === 'SERVICE_DEBIT_MERCHANT';
        case 'bills': // жёлтенькие
          return BILL_TYPES.includes(t) && (status === 'NEW' || status === 'DECLINE');
        case 'payoutsAndRefunds': // красненькие
          return t === 'PAYOUT' || t === 'REFUND';
        case 'partner':
          return t === PARTNER_PAYOUT_ACCRUAL;
        default:
          return false;
      }
    },
  },
};

export const calculateAmount = {
  methods: {
    calculateAmount(amount, commission) {
      return (amount + (commission || 0)) / 100;
    },
  },
};

export const luhn = {
  methods: {
    luhn(cardNumber) {
      let arr = [];

      cardNumber = cardNumber.toString();
      for (let i = 0; i < cardNumber.length; i++) {
        if (i % 2 === 0) {
          let m = parseInt(cardNumber[i]) * 2;
          if (m > 9) {
            arr.push(m - 9);
          } else {
            arr.push(m);
          }
        } else {
          let n = parseInt(cardNumber[i]);
          arr.push(n);
        }
      }
      let summ = arr.reduce((a, b) => a + b);
      return Boolean(!(summ % 10));
    },
  },
};

export const prettyCardNumber = {
  methods: {
    prettyCardNumber(cardNumber, creditCardType) {
      if (!Object.keys(creditCardType).length) {
        return cardNumber;
      }

      let offsets = [].concat(0, creditCardType.gaps, cardNumber.length);
      let components = [];

      for (let i = 0; offsets[i] < cardNumber.length; i++) {
        let start = offsets[i];
        let end = Math.min(offsets[i + 1], cardNumber.length);
        components.push(cardNumber.substring(start, end));
      }

      return components.join(' ');
    },
  },
};

export const formatPrice = {
  methods: {
    formatPrice(val, separator) {
      let value = String(val).replace(/\s/g, '');
      value = value.replace(/,/g, '.');

      let seperated = value.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
      return seperated;
    },
  },
};

export const getIconStyle = {
  methods: {
    getIconStyle(transaction) {
      if (transaction.type === 'PURCHASE_BILL' && (transaction.status === 'CREATED' || transaction.status === 'DECLINE')) {
        return 'bill';
      }
      return iconStyle[transaction.type];
    },
  },
};

export const getTransactionLink = {
  methods: {
    getTransactionLink(publicId) {
      return publicId;
    },
  },
};

let _timer = null;
export const debounce = {
  methods: {
    debounce(fn, delay) {
      if (_timer) {
        clearTimeout(_timer);
      }
      _timer = setTimeout(() => fn(), delay);
    },
  },
};
